// Stable IDs describe containers, never a claimed building or deposit destination.
export const portableContainers=[
 {code:'CASE-01',name:'Briefcase 1'},
 ...Array.from({length:8},(_,i)=>({code:`BOX-${String(i+1).padStart(2,'0')}`,name:`Transfer box ${i+1}`})),
];
export function portableContainer(value){
 const match=/^(CASE|BOX|STOR)-?(0[1-9]|[1-9][0-9])$/.exec(String(value||'').trim().toUpperCase());
 return match?{code:`${match[1]}-${match[2]}`,name:`${{CASE:'Briefcase',BOX:'Transfer box',STOR:'Storage'}[match[1]]} ${+match[2]}`} : null;
}
export const storageSides=box=>box?.location_kind==='container'?['L']:['L','R'];
export const storageSideLabel=(box,side)=>box?.location_kind==='container'?'Slabs':side==='L'?'Left':'Right';
